import { APP_ENV, type AppEnv } from "../app-env";

export const SENTRY_REPORTING_ENVS = ["stage-v2", "prod-v2"] as const;

export function isSentryReportingEnabled(env: AppEnv = APP_ENV): boolean {
  return env === "stage-v2" || env === "prod-v2";
}
